import { Checkbox, FormControlLabel } from "@mui/material";
import { useField } from "formik";
import { buildArtFieldLabel } from "./artFieldLabelUtils";
import { useArtFieldMetadata } from "./artFieldMetadataContext";

const FormikCheckbox = (props) => {
  const [field] = useField(props);
  const fieldMetadata = useArtFieldMetadata(props.name);
  const label = buildArtFieldLabel(props.label, fieldMetadata);

  return (
    <FormControlLabel
      control={<Checkbox name={props.name} {...field} checked={field.value} />}
      {...props}
      label={label}
    />
  );
};

export default FormikCheckbox;
